// PUBLIC TEMPLATES: the module's public face. The schemas and resolvers live
// in templateSchema.ts, the DDB row and the reserved names in templateRow.ts.
// The templates themselves are data in DDB (#344), served by GET
// /api/templates and written by an admin.

export * from "./templateSchema.js";
export * from "./templateRow.js";
